import { useQuery } from '@tanstack/react-query';

import { adminListUserComplaintCountApi } from '../../../api/supports/adminListUserComplaintCountApi';
import { adminListVenueComplaintCountApi } from '../../../api/supports/adminListVenueComplaintCountApi';
import { AdminListUserComplaintFilter } from '../../../graphql/API';
import { useAdminRole } from '../../useAdminRole';

export const useChatSupportTicketCounts = ({
  type,
  subtype,
}: {
  type: string;
  subtype?: string;
}) => {
  const { isCityManager, isSocial, marketIds } = useAdminRole();
  const { data: userSupportCount } = useQuery({
    queryKey: [
      'list-support-chat',
      'support-chat-count',
      {
        ...(type && { types: [type] }),
        ...(subtype && { subtypes: [subtype] }),
      },
    ],
    queryFn: ({ queryKey }) => {
      const [, , filters] = queryKey as [string, string, AdminListUserComplaintFilter];
      return adminListUserComplaintCountApi({
        ...filters,
        premium: true,
        notInTypes: ['User premium cancellation', 'Update Instagram', 'Update profile picture'],
      });
    },
    enabled: !isSocial,
  });

  const { data: venueSupportCount } = useQuery({
    queryKey: [
      'list-support-chat-venue',
      'support-chat-count-venue',
      {
        ...{
          subtypes: ['Other', null],
          ...(isCityManager && {
            marketIDs: marketIds.map((id) => String(id)),
          }),
        },
      },
    ],
    queryFn: ({ queryKey }) => {
      const [, , filters] = queryKey as [string, string, AdminListUserComplaintFilter];
      return adminListVenueComplaintCountApi({ ...filters });
    },
    enabled: !isSocial,
  });

  return { userSupportCount, venueSupportCount };
};
